<template>
    <div class="gh-newsletter">
        <div class="container">
            <div class="row middle-md p-lr-2">
                <div class="col-xs-12 col-md-1">
                    <div class="gh-newsletter__header">
                        <div class="icon">
                            <img src="/images/app/news-icon.svg">
                        </div>
                        <div class="divider"></div>
                        
                    </div>
                </div>

                <div class="col-xs-12 col-md-11">
                    <p class="heading gh-subform-heading">Sign up to our free educational e-newsletter for mental health professionals</p>
                    <gh-newsletter-signup></gh-newsletter-signup>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ghNewsletterSignup from '@/modules/newsletter/components/NewsletterSignup';

    export default {
        components: {ghNewsletterSignup}
    }
</script>

<style lang="scss" scoped>
.p-lr-2 {
    padding: 0 2rem;
}

.gh-subform-heading {
    margin-left: .7rem;
    margin-bottom: .7rem;
    font-size: 18px;
    font-weight: 600;
}

@media(max-width:1023px) {
    .gh-newsletter__header {
        display: none;
    }
}
</style>